import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./condition_schema_name.js";
//#region src/condition_schema_name_helper.ts
var condition_schema_name_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(conditionSchemaName) {
	switch (conditionSchemaName) {
		case "none": return "None";
		case "custom": return "Custom";
		case "one-of-menu-sections-is-selected-item": return "One of menu sections is selected item";
		case "one-of-menu-sections-are-in-cart": return "One of menu sections are in cart";
		case "one-of-menu-sections-are-selected-item-or-in-cart": return "One of menu sections are selected item or in cart";
		case "one-of-menu-items-is-selected-item": return "One of menu items is selected item";
		case "one-of-menu-items-are-in-cart": return "One of menu items are in cart";
		case "one-of-menu-items-are-selected-item-or-in-cart": return "One of menu items are selected item or in cart";
		case "pre-checkout-popup": return "Is pre-checkout popup";
		case "cart-view": return "Is cart view";
		case "dietary-restrictions-applied": return "Dietary restrictions applied";
		case "menu-section-is-recommendation": return "Menu section is recommendation pane";
	}
}
//#endregion
export { condition_schema_name_helper_exports, name };

//# sourceMappingURL=condition_schema_name_helper.js.map